import React from "react";
import AdminLayerBlueprint from "components/blueprints/AdminLayerBlueprint";
import AdminDashboardOverview from "./components/AdminDashboardOverview";
import AdminDashboardOrientation from "./components/AdminDashboardOrientation";
import AdminDashboardRecentActivity from "./components/AdminDashboardRecentActivity";
import AdminDashboardRecruitersTable from "./components/AdminDashboardRecruitersTable/AdminDashboardRecruitersTable";
import AdminDashboardOrdersTable from "./components/AdminDashboardOrdersTable/AdminDashboardOrdersTable";
import AdminDashboardClientsTable from "./components/AdminDashboardClientsTable/AdminDashboardClientsTable";
import AdminDashboardSupportTicketsTable from "./components/AdminDashboardSupportTicketsTable/AdminDashboardSupportTicketsTable";

function AdminDashboardPage() {
  return (
    <div className="bg-gray-100 py-2" style={{ minHeight: "calc(100vh - 60px)" }}>
      <div className="container mx-auto my-6 flex">
        <section id="left" className="pr-2 w-1/2">
          <AdminDashboardOverview />
          <AdminDashboardRecruitersTable />
          <AdminDashboardClientsTable />
          <AdminDashboardOrdersTable />
        </section>
        <section id="right" className="pl-2 w-1/2">
          <AdminDashboardOrientation />
          <AdminDashboardSupportTicketsTable />
          <AdminDashboardRecentActivity />
        </section>
      </div>
    </div>
  );
}

export default AdminLayerBlueprint(AdminDashboardPage);
